import React, { useEffect, useState } from "react";
import { Image } from "@react-pdf/renderer";
import { DALLAS_BASE } from "../api/bases";
import { patientFileDataUrl, patientFileRef } from "../api/patientFiles";

// The legacy chimlw copies (api.brainymed.com) still load through the dallas
// proxy, which only fetches allowlisted hosts. Our own intake files never do any
// more (10-15): they come from the v2 file route with the staff token, as a
// data: URL react-pdf can embed (api/patientFiles.js).
const PROXY =
  `${DALLAS_BASE}/v1/onboarding-images/proxy?url=`;

const withProxy = (url) =>
  url ? `${PROXY}${encodeURIComponent(url)}` : null;

/*
 * <SafeImage stored={img.front_url || img.fornt_image} folder="images" fallback={chimlwUrl} />
 * `stored`: a stored value of ours (bare name + folder, legacy URL or route URL);
 * `src` is still accepted for the same thing. `fallback`: used when ours can not
 * be loaded.
 */
const SafeImage = ({ stored, folder, src, fallback, style }) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const primary = stored || src;
    const ref = patientFileRef(primary, folder);

    const load = async () => {
      if (!ref) {
        if (isMounted) setImageSrc(withProxy(fallback));
        return;
      }
      if (ref.kind === "direct") {
        if (isMounted) setImageSrc(withProxy(ref.url));
        return;
      }
      try {
        const dataUrl = await patientFileDataUrl(primary, folder);
        if (isMounted) setImageSrc(dataUrl);
      } catch {
        if (isMounted) setImageSrc(withProxy(fallback));
      }
    };
    load();

    return () => {
      isMounted = false;
    };
  }, [stored, folder, src, fallback]);

  if (!imageSrc) return null;

  return <Image src={imageSrc} style={style} />;
};

export default SafeImage;
